'use client';

import React from 'react';
import { type ProjectWithAllRelations } from '@repo/database';
import { buildPageTheme } from '@repo/page-theme';
import { comfortaa, montserratAlternates } from '../../fonts';
import {
  Content as MetricsContent,
  ContentMode,
} from '../page/components/metrics';
import '../share/share.css';

export default function WidgetPage({
  project,
}: {
  project: ProjectWithAllRelations;
}): React.JSX.Element {
  const themeStyles = buildPageTheme(project);

  return (
    <main
      className={`min-w-[375px] h-full min-h-full ${montserratAlternates.variable} ${comfortaa.variable} bg-zb-section-fill font-montserrat-alternates grid`}
      style={themeStyles}>
      <MetricsContent mode={ContentMode.SHARE} project={project} />
    </main>
  );
}
